import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pds-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
  @Input() className: Array<string>;
  public classValue = "";

  constructor() { }
  
  ngOnChanges(){
    this.classValue = this.className.reduce((acc, currentValue) => `${acc} pds-label--${currentValue}`, "");
  }
  
  ngOnInit(): void {
  }

}
